import { Analytics, BugTracker } from "../../library";
import {
  Check,
  Dashboard,
  DataType,
  DensityAccount,
  Orientation,
  SIconType,
  SToggleSelect,
  Space,
  Tag,
} from "../../types";
import { Colors, Metrics } from "../../resources";
import React, { useCallback, useEffect, useState } from "react";
import { SIcon, SToggle } from "../atoms";
import { StyleSheet, View } from "react-native";
import {
  calculateNumberFromPercentage,
  filterSpaces,
  getTagId,
} from "../../utils";
import { useSettings, useSpaces, useTags } from "../../hooks";

import { AxiosResponse } from "axios";
import { Moment } from "moment-timezone";
import { SCalendar } from ".";
import SCheckButton from "../atoms/SCheckButton";
import SDivider from "../atoms/SDivider";
import SDropDown from "../molecules/SDropDown";
import SEditCapacityModal from "../organisms/SEditCapacityModal";
import SEditTagsModal from "./SEditTagsModal";
import SIconButton from "../molecules/SIconButton";
import SSpacer from "../atoms/SSpacer";
import STooltip from "../molecules/STooltip";
import moment from "moment";

interface IProps {
  view?: SIconType;
  updateSafeCapacity: (
    id: string,
    safeCapacity: number
  ) => Promise<AxiosResponse<any> | undefined>;
  addTag: (id: string, tag: string) => Promise<AxiosResponse<any> | undefined>;
  removeTag: (
    id: string,
    tag: string
  ) => Promise<AxiosResponse<any> | undefined>;
}

const SToolBar: React.FC<IProps> = ({
  view = SIconType.Table,
  updateSafeCapacity,
  addTag,
  removeTag,
}) => {
  const [tagEditModalVisible, setTagEditModalVisible] =
    useState<boolean>(false);

  const [switchButton, setSwitchButton] = useState<SIconType>(view);
  const [isLeftDisabled, setIsLeftArrowDisabled] = useState<boolean>(false);
  const [isRightDisabled, setIsRightArrowDisabled] = useState<boolean>(false);

  const { settings, writeSetting } = useSettings();
  const {
    setSpaceSafeCapacity,
    addSpaceTag,
    deleteSpaceTag,
    spaces,
    checkAllSpaces,
  } = useSpaces();
  const { tags, addTags } = useTags();

  useEffect(() => {
    moment().startOf("isoWeek").format("YYYY-MM-DD");
    setSwitchButton(
      settings?.dashboard === Dashboard.Table
        ? SIconType.Chart
        : SIconType.Table
    );
    writeSetting({
      date: moment().startOf("isoWeek").format("YYYY-MM-DD"),
    });
    setIsRightArrowDisabled(true);
  }, []);

  useEffect(() => {
    setSwitchButton(view);
  }, [view]);

  const resetDateToNow = () => {
    writeSetting({
      date: moment().startOf("isoWeek").format("YYYY-MM-DD"),
    });
    setIsRightArrowDisabled(true);
    setIsLeftArrowDisabled(false);
  };

  const setDate = (mDate: Moment) => {
    setIsLeftArrowDisabled(false);
    setIsRightArrowDisabled(false);
    if (
      mDate.isBefore(
        moment("2020-10-07T00:00:00.000").startOf("isoWeek").add(1, "week")
      )
    ) {
      setIsLeftArrowDisabled(true);
    }

    console.log(moment().startOf("isoWeek"));
    console.log(moment().startOf("isoWeek").subtract(1, "week"));

    console.log(mDate.isAfter(moment().startOf("isoWeek").subtract(1, "week")));

    if (mDate.isAfter(moment().startOf("isoWeek").subtract(1, "week"))) {
      setIsRightArrowDisabled(true);
    }
  };

  const onPressSwitch = () => {
    Analytics.track(
      `Portfolio ${switchButton === SIconType.Table ? "Chart" : "Table"} View`
    );

    setSwitchButton(
      switchButton === SIconType.Table ? SIconType.Chart : SIconType.Table
    );
    writeSetting({
      dashboard:
        switchButton === SIconType.Table ? Dashboard.Table : Dashboard.Chart,
    });
  };

  const goToLastWeek = () => {
    if (isRightDisabled) {
      setIsRightArrowDisabled(false);
    }
    let mDate = moment(settings?.date).subtract(1, "week");
    writeSetting({
      date: mDate.startOf("isoWeek").format("YYYY-MM-DD"),
    });
    if (mDate.isBefore(moment("2020-10-07T00:00:00.000").add(1, "week"))) {
      setIsLeftArrowDisabled(true);
    }
  };

  const goToNextWeek = () => {
    if (isLeftDisabled) {
      setIsLeftArrowDisabled(false);
    }
    let mDate = moment(settings?.date).add(1, "week");
    writeSetting({
      date: mDate.startOf("isoWeek").format("YYYY-MM-DD"),
    });
    if (mDate.isAfter(moment().subtract(1, "week"))) {
      setIsRightArrowDisabled(true);
    }
  };

  const onCheck = (check: Check) => {
    checkAllSpaces(check === Check.Checked ? true : false);
  };

  const getSelectedCount = () => {
    const filterdSpaces = filterSpaces(spaces, tags, settings?.search);

    return filterdSpaces.filter(
      (space: Space) => space.selected && space.filtered
    ).length;
  };

  const getSelectedSpaces = () => {
    const filterdSpaces = filterSpaces(spaces, tags, settings?.search);

    return filterdSpaces.filter(
      (space: Space) => space.selected && space.filtered
    );
  };

  const getAllCheckStatus = useCallback((): Check => {
    let check = false;
    let uncheck = false;
    for (let space of spaces) {
      if (space?.selected) {
        check = true;
      } else {
        uncheck = true;
      }
    }
    if (check && uncheck) {
      return Check.Group;
    }

    return check ? Check.Checked : Check.Unchecked;
  }, [spaces]);

  const setSafeCapacity = async (capacity: string) => {
    //If written in backend then update app state
    return new Promise((resolve, reject) => {
      const parsed = parseInt(capacity);
      if (isNaN(parsed)) {
        return 0;
      }

      let filteredSpaces = filterSpaces(spaces, tags, settings?.search);

      filteredSpaces
        .filter((space: Space) => space.selected)
        .map(async (checkedSpace: Space) => {
          const capacity = isNaN(parsed)
            ? 0
            : calculateNumberFromPercentage(
                parsed,
                checkedSpace.target_capacity
              );

          try {
            await updateSafeCapacity(checkedSpace.id, capacity);
            setSpaceSafeCapacity(checkedSpace.id, capacity);
            resolve(true);
          } catch (error) {
            BugTracker.captureException(error);
            resolve(false);
          }
        });
    })
      .then((complete) => {})
      .catch((error) => {});
  };

  const onAddTag = (tag: Tag) => {
    const tagName = getTagId(tag.title, tag.category);

    getSelectedSpaces().map(async (space: Space) => {
      try {
        await addTag(space.id, tagName);
        addSpaceTag(space.id, tagName);
      } catch (error) {
        BugTracker.captureException(error);
      }
    });
    let newTags = tags;
    newTags[`${tagName}`] = { ...tag, number: getSelectedSpaces().length };
    addTags(newTags);
  };

  const onPressToggleLeft = () => {
    writeSetting({
      safe: DataType.SafeCapacityPpl,
      busiest: DataType.BusiestPpl,
      average: DataType.AveragePpl,
    });
  };

  const onPressToggleRight = () => {
    writeSetting({
      safe: DataType.SafeCapacityPercentage,
      busiest: DataType.BusiestPercentage,
      average: DataType.AveragePercentage,
    });
  };

  const onDeleteTag = async (tag: Tag) => {
    const tagName = getTagId(tag.title, tag.category);

    await Promise.all(
      getSelectedSpaces().map(async (space: Space) => {
        if (space.tags.includes(tagName)) {
          try {
            if (
              settings &&
              settings.impersonate &&
              settings.impersonate !== DensityAccount.DEMO
            ) {
              await removeTag(space.id, tagName);
            }
            deleteSpaceTag(space.id, tagName);
          } catch (error) {
            BugTracker.captureException(error);
          }
        }
      })
    );
    // Remove tag if was removed from all spaces

    if (
      spaces.filter((space: Space) => space.tags.includes(tagName)).length === 0
    ) {
      let newTags = tags;
      delete newTags[`${tagName}`];
      addTags(newTags);
    }
  };

  const selectCapacity = (capacity: DataType) => {
    writeSetting({
      capacity: capacity,
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.leftBar}>
        <SCheckButton checkType={getAllCheckStatus()} onCheck={onCheck} />
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        <STooltip content={"Safe Percentage"}>
          <SIconButton
            type={SIconType.Safe}
            disabled={getAllCheckStatus() === Check.Unchecked}
          >
            <SEditCapacityModal
              selected={getSelectedCount()}
              onSave={setSafeCapacity}
            />
          </SIconButton>
        </STooltip>
        <SSpacer
          type={Orientation.Horizontal}
          space={Metrics.paddingSuperSmall}
        />
        <STooltip content={"Tags"}>
          <SIconButton
            type={SIconType.Tag}
            disabled={getAllCheckStatus() === Check.Unchecked}
          >
            <SEditTagsModal
              selected={getSelectedCount()}
              spaces={getSelectedSpaces()}
              onDeleteTag={onDeleteTag}
              onAddTag={onAddTag}
              onSave={() => {}}
            />
          </SIconButton>
        </STooltip>
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        <SDivider height={Metrics.iconMedium} color={Colors.grey300} />
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
      </View>
      <View style={styles.rightBar}>
        <SSpacer
          type={Orientation.Horizontal}
          space={Metrics.padding8 + 2 * Metrics.iconSmall}
        />
        <SDropDown
          choices={[
            { name: "Target Capacity", value: DataType.TargetCapacity },
            { name: "Legal Capacity", value: DataType.LegalCapacity },
          ]}
          selection={settings?.capacity === DataType.LegalCapacity ? 1 : 0}
          onPress={selectCapacity}
        />
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        <SToggle
          selected={
            settings?.safe === DataType.SafeCapacityPercentage
              ? SToggleSelect.RIGHT
              : SToggleSelect.LEFT
          }
          height={Metrics.menu44}
          iconLeft={
            <SIcon type={SIconType.Number} color={Colors.blue700} size={32} />
          }
          iconRight={
            <SIcon
              type={SIconType.Percentage}
              color={Colors.blue700}
              size={32}
            />
          }
          onPressLeft={onPressToggleLeft}
          onPressRight={onPressToggleRight}
        />
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        {switchButton === SIconType.Chart ? (
          <>
            <SDivider height={Metrics.iconMedium} color={Colors.grey300} />
            <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
            <SCalendar
              week={settings?.date ? settings.date : ""}
              isOpen={false}
              onPress={resetDateToNow}
              onSetDate={setDate}
            />
            <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
            <SIconButton
              type={SIconType.ArrowLeft}
              isContainer
              disabled={isLeftDisabled}
              onPress={goToLastWeek}
              size={Metrics.iconLarge}
            />

            <SSpacer
              type={Orientation.Horizontal}
              space={Metrics.paddingSuperSmall}
            />
            <SIconButton
              type={SIconType.ArrowRight}
              isContainer
              disabled={isRightDisabled}
              // containerStyle={styles.shadow}
              onPress={goToNextWeek}
              size={Metrics.iconLarge}
            />
          </>
        ) : null}
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        <SDivider height={Metrics.iconMedium} color={Colors.grey300} />
        <SSpacer type={Orientation.Horizontal} space={Metrics.padding8} />
        <STooltip
          content={`${
            switchButton === SIconType.Table ? "Table" : "Chart"
          } View`}
        >
          <SIconButton type={switchButton} onPress={onPressSwitch} />
        </STooltip>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    height: Metrics.menu44,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: Colors.grey300,
    borderBottomWidth: 0,
    backgroundColor: Colors.white,
    shadowColor: Colors.shadow,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 5,
    shadowOpacity: 0.4,
    elevation: 5,
    zIndex: 1,
  },
  leftBar: {
    flexShrink: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginLeft: Metrics.padding32 + Metrics.padding8,
  },
  middleBar: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginRight: Metrics.padding32,
    marginLeft: Metrics.padding16,
  },
  rightBar: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginRight: Metrics.padding32,
  },
  iconContainer: {
    width: Metrics.iconSmaller,
  },
  shadow: {
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
});

export default SToolBar;
